import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ReturnClass } from 'projects/Shared-Lib/model/search-result';
import * as _ from 'underscore';

interface PagerContent {
  TotalItems: number,
  CurrentPage: number,
  PageSize: number,
  TotalPages: number,
  StartPage: number,
  EndPage: number,
  StartIndex: number,
  EndIndex: number,
  Pages: number[]
}


@Component({
  selector: 'app-table-pager',
  templateUrl: './table-pager.component.html',
  styleUrls: ['./table-pager.component.css']
})
export class TablePagerComponent {
  @Input() Income: ReturnClass;
  @Output() PageInfo = new EventEmitter<any>();
  dataAllSource: any[] = [];
  selectedSize?: any;

  description: string;
  pager: PagerContent;
  pageSize: number;
  pageOptions = [
    { size: 1, name: '1' },
    { size: 10, name: '10' },
    { size: 25, name: '25' },
    { size: 50, name: '50' }
  ];

  pagedItems: any[];

  constructor() {
    this.pager = {
      TotalItems: 0,
      CurrentPage: 1,
      PageSize: 10,
      TotalPages: 0,
      StartPage: 0,
      EndPage: 0,
      StartIndex: 0,
      EndIndex: 0,
      Pages: []
    };
  }

  ngOnChanges() {
    let page: number = 1;
    if (this.Income !== undefined) {
      page = this.Income.draw;
      // 取得本頁次該顯示之項目
      if (typeof (this.selectedSize) !== 'undefined') {
        this.pageSize = this.selectedSize.size;
      }
      else {
        this.pageSize = this.Income.pagingSize;
        this.selectedSize = { size: this.Income.pagingSize, name: this.Income.pagingSize };
      }

      this.setPage(page, this.Income.recordsFiltered, this.Income.data);
    }
  }


  //設定分頁器
  setPage(page: number, totalRecords: number, pDataAllSource: any[]) {
    if (page < 1 || page > totalRecords) {
      page = 1;
      totalRecords = 0;
    }

    // get pager object from service
    this.pager = this.getPager(totalRecords, page, this.pageSize);
    // 取得本頁次該顯示之項目
    this.pagedItems = pDataAllSource;
    this.description = `Showing ${this.pager.StartIndex + 1} to ${this.pager.EndIndex + 1} of ${this.pager.TotalItems} entries`;
  }

  /** 設定分頁器
   * 頁次 click event - trigger parent Search function
   * *///
  pagerSetting(page: number) {
    this.setPage(page, this.Income.recordsFiltered, this.dataAllSource);

    let pageInfo = {
      PageSize: this.pageSize,
      CurrentPage: page
    };
    this.PageInfo.emit(pageInfo);
  }

  //計算並回傳分頁器相關參數 , e.q. startIndex , endIndex ...
  getPager(totalItems: number, currentPage: number = 1, pageSize: number = 10) {
    // calculate total pages
    let totalPages = Math.ceil(totalItems / pageSize);
    let startPage: number, endPage: number;
    if (totalPages <= 5) {
      startPage = 1;
      endPage = totalPages;
    } else {
      if (currentPage <= 3) {
        startPage = 1;
        endPage = 5;
      } else if (currentPage + 1 >= totalPages) {
        startPage = totalPages - 4;
        endPage = totalPages;
      } else {
        startPage = currentPage - 2;
        endPage = currentPage + 2;
      }
    }

    // calculate start and end item indexes
    let startIndex = (currentPage - 1) * pageSize;
    let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);
    // create an array of pages to ng-repeat in the pager control
    let pages = _.range(startPage, endPage + 1);

    let pageContent: PagerContent = {
      TotalItems: totalItems,
      CurrentPage: currentPage,
      PageSize: pageSize,
      TotalPages: totalPages,
      StartPage: startPage,
      EndPage: endPage,
      StartIndex: startIndex,
      EndIndex: endIndex,
      Pages: pages
    };
    // return object with all pager properties required by the view
    return pageContent;
  }

  //select: ngModelChange , when change pagesize , back to page 1
  changePageSize() {
    this.pageSize = +this.selectedSize.size;
    this.pager.CurrentPage = 1;

    let pageInfo = {
      PageSize: this.pageSize,
      CurrentPage: this.pager.CurrentPage
    };
    this.PageInfo.emit(pageInfo);
  }
  onBackdropClicked() {
  }
}
